"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { track } from "@/components/analytics/track";

/**
 * Auto pageview tracker for public site routes. Mount once in root layout.
 * Skips /admin via track() path filter.
 */
export function VisitorTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname) return;
    if (pathname.startsWith("/admin")) return;

    const search = searchParams?.toString();
    const key = search ? `${pathname}?${search}` : pathname;
    if (lastKey.current === key) return;
    lastKey.current = key;

    track("pageview", { path: key });
  }, [pathname, searchParams]);

  return null;
}
